import { GetUsersByClients, SendEmailToUsers } from "../../api/sendEmail-users";

const sendEmail = {
  namespaced: true,
  state: () => ({
    usersByClientsData: null,
    sendEmailToUsersData: null,
  }),
  getters: {
    getUsersByClientsData: (state) => {
      return state.usersByClientsData;
    },
    getSendEmailToUsers: (state) => {
      return state.sendEmailToUsersData;
    },
  },
  actions: {
    fetchUsersByClients({ state, commit }, payload) {
      console.log(payload);
      return new Promise((resolve, reject) => {
        GetUsersByClients(payload)
          .then((data) => {
            resolve(data);
            state.usersByClientsData = data.Result;
          })
          .catch((err) => {
            console.log("error while fetchUsersByClients" + err);
          });
      });
    },

    fetchSendEmailToUsers({ state, commit }, payload) {
      console.log(payload);
      return new Promise((resolve, reject) => {
        SendEmailToUsers(payload)
          .then((data) => {
            resolve(data);
            state.sendEmailToUsersData = data;
          })
          .catch((err) => {
            console.log("error while fetchSendEmailToUsers" + err);
          });
      });
    },
  },
  mutations: {},
};

export default sendEmail;
